import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './webflow.css'
import './template/master.css'
import registerServiceWorker from './registerServiceWorker';
import Header from './components/Header'
import FormContainer from './components/FormContainer'
import FormTitle from './components/FormTitle'
import FormText from './components/FormText'
import Form from './components/Form'
import Footer from './components/Footer'
import { render } from 'react-snapshot';

const FormWrapper = () => {
  return(
    <div className="lead-form">
    <Header />
    <FormContainer>
      <FormTitle />
      <FormText />
      <Form />
    </FormContainer>
    <Footer />
  </div>
  )
}

render(<FormWrapper />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js